export default __webpack_public_path__ + "static/media/moderne-elektroinstallation.f452e405.webp";